import {
  AVAILABLE_STATUS_BLUE,
  LIGHT_SOY,
  MEDIUM_SOY
} from 'reservations/brand/helpers/v1/palette';

type DayStyles = {
  outsideCurrentMonth: boolean;
  selected?: boolean;
  today?: boolean;
  disabled?: boolean;
  isPastDate: boolean;
  isClosed: boolean;
  isAvailable: boolean;
  isUnavailable: boolean;
  primaryColor?: string;
};

const defaultBadgeStyles = {
  width: '6px',
  height: '6px',
  borderRadius: '50%'
};
const defaultDayStyles = {
  color: 'white',
  border: 0,
  height: '32px',
  width: '32px'
};

export function getDayStyles({
  outsideCurrentMonth,
  selected,
  today,
  disabled,
  isPastDate,
  isClosed,
  isAvailable,
  isUnavailable,
  primaryColor = AVAILABLE_STATUS_BLUE
}: DayStyles) {
  let dayStyles = null;
  let badgeStyles = null;

  if (isPastDate) {
    dayStyles = null;
    badgeStyles = null;
  } else if (isClosed && !disabled) {
    dayStyles = { textDecoration: 'line-through', color: LIGHT_SOY };
  } else if (selected && isAvailable) {
    dayStyles = {
      ...defaultDayStyles,
      background: AVAILABLE_STATUS_BLUE
    };
  } else if (selected && isUnavailable) {
    dayStyles = {
      ...defaultDayStyles,
      background: `${LIGHT_SOY} !important`
    };
  } else if (isAvailable && !today && !outsideCurrentMonth && !disabled) {
    badgeStyles = {
      ...defaultBadgeStyles,
      background: primaryColor
    };
  } else if (isUnavailable && !today && !outsideCurrentMonth && !disabled) {
    badgeStyles = {
      ...defaultBadgeStyles,
      border: `1px solid ${MEDIUM_SOY}`
    };
  }
  return { dayStyles, badgeStyles };
}
